import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeterQueryResultDto } from '@app/api/dmc';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { htxPartialTable } from '@shared/partials/htx-partial.table';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { meterNumberPartial } from '@shared/columns/meteringpoint.columns';

export const meterpointQueryResultTable: TableConfig<MeterQueryResultDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'meteringpoint.meter.serialnumber',
      key: 'meterSerialNumber'
    },
    meterNumberPartial,
    {
      title: 'common.quadrant',
      key: 'quadrant'
    },
    validFromPartialTable,
    validToPartialTable,
    {
      title: 'meteringpoint.meter.controlmeter',
      key: 'verificationMeter',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        false: 'common.no',
        true: 'common.yes'
      }
    },
    datahubPartial,
    htxPartialTable,
    {
      title: 'meteringpoint.meter.comments',
      key: 'validation'
    }
  ],
}
